import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { jsPDF } from "jspdf";
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { LoanService } from "../../shared/loan.service";
import { environment } from '../../../../environments/environment';
import { Loan } from "../loan";

@Injectable({
  providedIn: 'root'
})

export class PrintinstallmentService {

  public selectedLoan: Loan;
  constructor(private httpClient: HttpClient,
    private loanService: LoanService, public datePipe: DatePipe,) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  GenerateReport(rptSearchData: any) {

    this.FetchInstallment(rptSearchData)
      .toPromise()
      .then(data => {

        if (data.length > 0) {
            this.ReportGenerateList(data, this.datePipe);
        }
        else {
          console.log('data not found!');
        }
      })
      .catch(err => { console.log(err) });
  }

  FetchInstallment(rptSearchData: any) {
    this.selectedLoan = new Loan();
    this.selectedLoan.CustomerId = rptSearchData.customerId;
    this.selectedLoan.ReportName = rptSearchData.ReportName;
    this.selectedLoan.ToDate = rptSearchData.LoanToDate;
    this.selectedLoan.BranchId = rptSearchData.BranchId;
    this.selectedLoan.CentreId = rptSearchData.CentreId;

    this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoan.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLoan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loan/Report', body, { headers: headers });
  }

  //--------------------------------------------------
  // Printing the documents as a lists.  
  ReportGenerateList(CollectionList: any, datePipe: DatePipe) {

    var generateData = function (CollectionList) {

      var result = [];
      var itemData = [{}];     
      // let todayDate = new Date(); 
      // console.log(datePipe.transform(todayDate, 'yyyy-MM-dd'));

      for (var i = 0; i < CollectionList.length; i += 1) {
        itemData[i] = {
          Id: CollectionList[i].Id.toString(),
          'No.': CollectionList[i].Period.toString(),
          'Installment Date': datePipe.transform(CollectionList[i].LoanPayDate, 'dd-MM-yyyy').toString(),        
          'Principle Amount': CollectionList[i].PrincipleAmount.toString(),
          'Interest Amount': CollectionList[i].InterestAmount.toString(),
          'Savings Amount': CollectionList[i].SavingsDemand.toString(),
          'Installment Amount': CollectionList[i].TotalDemand.toString(),
          'Recieved Amount':  CollectionList[i].PaidAmount.toString() != 0 ? CollectionList[i].PaidAmount.toString() : String(' '),
          'Recieved Date': CollectionList[i].TransactionDate.toString() != '0001-01-01T00:00:00' ? datePipe.transform(CollectionList[i].TransactionDate, 'dd-MM-yyyy').toString() : String(' '),
        };
      }

      for (var i = 0; i < CollectionList.length; i += 1) {
        itemData[i]['Id'] = (i + 1).toString();
        result.push(Object.assign({}, itemData[i]));
      }
      return result;
    };

    function createHeaders(HeaderName) {

      var HeaderResult = [];
      for (var i = 0; i < HeaderName.length; i += 1) {
        HeaderResult.push({
          id: HeaderName[i],
          name: HeaderName[i],
          prompt: HeaderName[i],
          width: 90,
          align: "left",
          padding: 0,
        });
      }
      return HeaderResult;
    }

    var headers = createHeaders([
      "No.",
      "Installment Date",
      "Principle Amount",
      "Interest Amount",
      "Savings Amount",
      "Installment Amount",
      "Recieved Amount",
      "Recieved Date",
    ]);

    // Document of 210mm wide and 297mm high
    // new jsPDF('p', 'mm', [297, 210]);
    // // Document of 297mm wide and 210mm high
    // new jsPDF('l', 'mm', [297, 210]);
    // // Document of 5 inch width and 3 inch high
    // new jsPDF('l', 'in', [3, 5]);

    // let pdf = new jsPDF('l', 'pt', 'legal');    
    // let pdf = new jsPDF('l', 'pt', 'letter');
    let pdf = new jsPDF('p', 'pt', 'A4');
    //   let pdf = new JsPDF(  
    //     Orientation, // Landscape or Portrait     
    //     unit, // mm, cm, in     
    //     format // A2, A4 etc  
    // );  

    pdf.setProperties({
      title: 'Loan Installment',
      subject: 'Info about PDF',
      author: 'PDFAuthor',
      keywords: 'LoanInstallment, javascript, web 2.0, ajax',
      creator: 'SRI'
    });

    let todayDate = new Date();

    // Top HEADER
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(14);
    pdf.setFont('arial', 'normal');
    pdf.text("Society For Rural Improvements", 210, 40);  // 40 is the height
    pdf.text("Loan Installment ", 250, 60);
    pdf.text("Statement on  " + datePipe.transform(todayDate, 'dd-MM-yyyy'), 225, 80);
    pdf.setLineWidth(1);
    pdf.line(5, 105, 590, 105)
    // Top HEADER END 

    // Second Top HEADER
    pdf.setFontSize(10);
    pdf.setFont('arial', 'normal');
    pdf.text("CUSTOMER: " + CollectionList[0].CustomerName.toString(), 25, 120);
    pdf.text("BRANCH	: " + CollectionList[0].CustomerBranchName.toString(), 25, 140);
    pdf.text("CENTRE	: " + CollectionList[0].CentreName.toString(), 25, 160);
    pdf.text("SCHEME	: " + CollectionList[0].SchemeName.toString(), 25, 180);
    pdf.text("LOAN NO.  :" + CollectionList[0].LoanNumber.toString(), 400, 120);
    pdf.text("LOAN DATE :" + datePipe.transform(CollectionList[0].LoanApprovedDate, 'dd-MM-yyyy').toString(), 400, 140);
    pdf.text("LOAN AMOUNT	 :" + CollectionList[0].LoanAmount.toString(), 400, 160);  
    let count = CollectionList.length - 1;
    pdf.text("MATURITY DATE:" + datePipe.transform(CollectionList[count].LoanPayDate, 'dd-MM-yyyy').toString(), 400, 180);

    pdf.line(5, 185, 590, 185)   // x-axis, -x-axix,  y-axis  , -y-axix
    pdf.table(20, 195, generateData(CollectionList), headers, { autoSize: false });
    pdf.output('dataurlnewwindow');
  }
}
